export default __webpack_public_path__ + "static/media/ftj-6.0afca86b.jpeg";